import { render, staticRenderFns } from "./PerformanceMetrics.vue?vue&type=template&id=23055da6"
import script from "./PerformanceMetrics.vue?vue&type=script&lang=js"
export * from "./PerformanceMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports